import React, { useState, useEffect } from "react";
import { TableBuilder, TableBuilderColumn } from "baseui/table-semantic";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { fetchDeposits } from "../../redux/user/UserThunk";
import LoadingOverlay from "../../components/loading-overlay/LoadingOverlayComponent";
import { format } from "date-fns";
import { Block } from "baseui/block";
import { LabelMedium } from "baseui/typography";
import { Pagination } from "baseui/pagination";
import { createOrganizationDepositSession } from "../../helpers/PaymentHelpers";
import { styled } from "baseui";
import { Input } from "baseui/input";
import { Button } from "baseui/button";
import { Tag, VARIANT } from "baseui/tag";
import PaginatedTable from "../../components/paginated-table/PaginatedTable";
import PremiumLock from "../../components/premium-lock/PremiumLockComponent";
const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  height: "100%",
  maxWidth: "800px",
  margin: "0 auto",
});

const TableAndPaginationContainer = styled("div", {
  display: "flex",
  minHeight: "60vh",
  overflow: "hidden",
  alignItems: "center",
  flexDirection: "column",
  justifyContent: "space-between",
});
const PAGE_SIZE = 7;
function formatNumber(num) {
  return num.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function formatCurrency(value) {
  return `$${Number(value / 100).toFixed(4)}`;
}
const columns = [
    {
      header: "ID",
      cell: (row) => <LabelMedium>{row.id}</LabelMedium>
    },
    {
      header: "Type",
      cell: (row) => (
        <Tag closeable={false} variant={VARIANT.solid} kind={row.transactionType === "DEPOSIT" ? "positive" : "negative"}>
          {row.transactionType.charAt(0).toUpperCase() + row.transactionType.slice(1)}
        </Tag>
      )
    },
    {
      header: "Source",
      cell: (row) => <LabelMedium>{"Payment"}</LabelMedium>
    },
    {
      header: "Amount",
      cell: (row) => <LabelMedium>{formatCurrency(row.amount)}</LabelMedium>
    },
    {
      header: "Create Date",
      cell: (row) => <LabelMedium>{format(new Date(row.createdAt), "yyyy-MM-dd - HH:mm")}</LabelMedium>
    }
  ];
function UserAccountDeposit(props) {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  const [amount, setAmount] = useState("");
  const [isValidAmount, setIsValidAmount] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [tokenHistory, setTokenHistory] = useState([null]); // Initialize with the starting page token

  useEffect(() => {
    props.onFetchDeposits(props.organizationId, PAGE_SIZE, tokenHistory[0]);
  }, []);

  const handleFetchData = (token) => {
    props.onFetchDeposits(props.organizationId, PAGE_SIZE, token);
  };
  const validateAndSetAmount = (value) => {
    const formattedValue = formatNumber(value);
    const valid = /^\d+$/.test(formattedValue.replace(/,/g, "")); // Validates positive whole numbers
    setIsValidAmount(valid);
    setAmount(formattedValue);
  };
  const handleManagePaymentAccount = async () => {
    if (!isValidAmount) return;
    setIsLoading(true);
    try {
      let res = await createOrganizationDepositSession(amount);
      if (res) {
        window.location.href = res;
      }
    } catch (error) {
      console.error("Failed to create checkout session:", error);
    } finally {
      setAmount("");
      setIsValidAmount(false);
      setIsLoading(false);
    }
  };
  if (props.user?.subscription?.plan !== "PREMIUM") {
    return <PremiumLock />;
  }

  return (
    
    <Container>
   
      <LoadingOverlay isLoading={props.fetchInProgress} />
      <Block
        display="flex"
        justifyContent="space-between"
        gap="scale100"
        alignItems="center"
        marginBottom="scale100"
        style={{ maxWidth: "500px", margin: "0 auto" }}  // Center this block
      >
        <Input
          overrides={{
            Root: {
              style: {
                width: "200px",
                marginRight: "12px",
              },
            },
          }}
          value={amount}
          startEnhancer="$"
          endEnhancer=".00"
          onChange={(e) => validateAndSetAmount(e.target.value)}
          placeholder="0"
          type="dollar"
        />
        <Button
          onClick={handleManagePaymentAccount}
          isLoading={isLoading}
          disabled={!isValidAmount}
        >
          Deposit
        </Button>
      </Block>
      <TableAndPaginationContainer>
      <PaginatedTable
          data={props.deposits}
          columns={columns}
          nextToken={props.nextToken}
          onNext={handleFetchData}
          onPrev={handleFetchData}
      />
      </TableAndPaginationContainer>
    </Container>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    organizationId: state.user?.primaryOrgId || {},
    deposits: state.user?.deposits || [],
    fetchInProgress: state.user.fetchDepositsInProgress,
    fetchError: state.user.fetchDepositsError,
    fetchErrorMessage: state.user.fetchDepositsErrorMessage,
    nextToken: state.user.fetchDepositsNextToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchDeposits: (organizationId, size, nextToken) => {
      dispatch(fetchDeposits(organizationId, size, nextToken));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAccountDeposit);
